module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/fallback_524_360_b5e3053.jpg";